
/* injects from baggage-loader */

export default function (app) {
  app
    .factory('TTS', TTSFactory);

  function TTSFactory() {
    'ngInject';

    let self = {}

    self.utterance = {}

    self.pause = function(){
      //self.utterance.onend = null
      window.speechSynthesis.pause();
    }

    self.resume = function(){
      //self.utterance.onend = null
      window.speechSynthesis.resume();
    }

    self.onend = function(){
      //self.utterance.onend = null
      console.log("fim");
    }
   
   

   self.speaking = function(){
      return window.speechSynthesis.speaking;
    }

    self.paused = function(){
      return window.speechSynthesis.paused;
    }

    self.speak = function(text, onend){
      self.utterance = new SpeechSynthesisUtterance(text);
      self.tts_config_defaults(self.utterance, onend);
      self.play(self.utterance);
    },

    self.clear = function(){
      self.utterance.onend = null
      window.speechSynthesis.cancel();
    }

    self.play = function(speech){
      window.speechSynthesis.speak(speech);
    }

    self.tts_config_defaults = function(speech, onend){
      speech.lang = "pt-BR";
      speech.rate = 0.8;
      speech.onerror = function(){
        self.clear();
      }
      speech.onend = onend;
    }

    
    return self;
  }
}



// WEBPACK FOOTER //
// ./src/app/core/services/tts.factory.js